import Vue from 'vue';
import VCharts from 'v-charts';

Vue.use(VCharts);

// 全局使用
